import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../CSS/styles.css";
import n1 from "../../assets/Container.png";
import n2 from "../../assets/n2.png";
import n3 from "../../assets/n3.png";
import n4 from "../../assets/n4.png";
import n5 from "../../assets/f6.png";
import n6 from "../../assets/f5.png";
import Calender from "../../assets/calender.png";

const NewsPost = () => {
  const [selectedOption, setSelectedOption] = useState("All Posts");

  const images = [
    {
      src: n1,
      alt: "New Cyber Security Threats in 2023",
      categories: ["Cyber Security"],
      date: "June 30, 2023",
      icon: Calender,
      title: "New Cyber Security Threats in 2023",
      desc: "Our analysis of emerging cyber threats and how organizations can protect themselves in an increasingly complex digital landscape.",
    },
    {
      src: n2,
      alt: "Crisis Management Best Practices",
      categories: ["Crisis Management"],
      date: "May 10, 2023",
      icon: Calender,
      title: "Crisis Management Best Practices",
      desc: "Key strategies for effective crisis management in uncertain times. Learn how to prepare, respond, and recover from organizational crises.",
    },
    {
      src: n3,
      alt: "The Future of GIS Technology",
      categories: ["GIS"],
      date: "April 18, 2023",
      icon: Calender,
      title: "The Future of GIS Technology",
      desc: "How Geographic Information Systems are evolving and transforming industries. Explore the latest trends and applications of GIS technology.",
    },
    {
      src: n4,
      alt: "Developing a Comprehensive Risk Assessment Framework",
      categories: ["Risk Management"],
      date: "March 05, 2023",
      icon: Calender,
      title: "Developing a Comprehensive Risk Assessment Framework",
      desc: "A step-by-step guide to creating and implementing an effective risk assessment framework for your organization.",
    },
    {
      src: n5,
      alt: "Securing Your Digital Transformation Journey",
      categories: ["Digital Solutions"],
      date: "February 20, 2023",
      icon: Calender,
      title: "Securing Your Digital Transformation Journey",
      desc: "Essential security considerations for organizations undergoing digital transformation initiatives.",
    },
    {
      src: n6,
      alt: "Building Effective Security Training Programs",
      categories: ["Training"],
      date: "January 15, 2023",
      icon: Calender,
      title: "Building Effective Security Training Programs",
      desc: "How to develop and implement security training that actually changes behavior and improves organizational security.",
    },
  ];

  const radioOptions = [
    "All Posts",
    "Risk Management",
    "Crisis Management",
    "Cyber Security",
    "GIS",
    "Digital Solutions",
    "Training",
  ];

  return (
    <>
      {/* Filter bar */}
      <div
        className="container-fluid px-0"
        style={{ backgroundColor: "#F9FAFB" }}
      >
        <div
          className="container d-flex align-items-center flex-wrap py-4 px-4 gap-2"
          style={{
            backgroundColor: "#F9FAFB",
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          {radioOptions.map((label) => (
            <button
              key={label}
              className={`btn px-3 py-2 fw-medium`}
              style={{
                backgroundColor:
                  selectedOption === label ? "#2C2F76" : "#FFFFFF",
                color: selectedOption === label ? "#FFFFFF" : "#6B7280",
              }}
              onClick={() => setSelectedOption(label)}
            >
              {label}
            </button>
          ))}

          <div className="ms-auto">
            <input
              className="form-control"
              type="text"
              placeholder="Search articles..."
              style={{ width: "250px" }}
            />
          </div>
        </div>
      </div>

      {/* News cards */}
      <div className="container-fluid inter m-0">
        <div className="container py-5">
          <div className="row">
            {images
              .filter(
                ({ categories }) =>
                  selectedOption === "All Posts" ||
                  categories.includes(selectedOption)
              )
              .map(
                ({ src, alt, title, desc, date, icon, categories }, index) => (
                  <div key={index} className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="card h-100 shadow-sm border-0">
                      <img
                        src={src}
                        alt={alt}
                        className="card-img-top"
                        style={{
                          height: "200px",
                          objectFit: "cover",
                          borderTopLeftRadius: "0.5rem",
                          borderTopRightRadius: "0.5rem",
                        }}
                      />
                      <div className="card-body">
                        {/* Date with Calendar Icon */}
                        <div className="d-flex align-items-center text-muted mb-2">
                          <img
                            src={icon}
                            alt="calendar"
                            style={{
                              width: "16px",
                              height: "16px",
                              marginRight: "6px",
                            }}
                          />
                          <span style={{ fontSize: "0.85rem" }}>{date}</span>
                        </div>

                        <h5
                          className="fw-semibold"
                          style={{ color: "#2C2F76" }}
                        >
                          {title}
                        </h5>
                        <p
                          className="text-muted"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {desc}
                        </p>
                        <p>{categories}</p>
                        {index === 0 ? (
                          <Link
                            to="/Insights"
                            className="btn btn-link px-0"
                            style={{ color: "#2C2F76", textDecoration: "none" }}
                          >
                            Read More
                          </Link>
                        ) : (
                          <button
                            className="btn btn-link px-0"
                            style={{ color: "#2C2F76", textDecoration: "none" }}
                          >
                            Read More
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsPost;
